(function (t) {
// fr
t.add("error.pagetitle", "Erreur", "errors", "fr");
t.add("error.title", "Oups...", "errors", "fr");
t.add("error.text", "Il semble que quelque chose se soit mal pass\u00e9.<br \/> On y travaille.", "errors", "fr");
t.add("error.redirect", "Retourner \u00e0 la page d'accueil", "errors", "fr");
})(Translator);
